export default __webpack_public_path__ + "static/media/jcdecaux.524f1987.jpg";